import opentype, { Font } from 'opentype.js';

type FRes = Font | null | undefined;

/** 防止重复请求字体信息 */
const cacheFontInfoMap = new Map<string, Promise<FRes>>();

export const getFontInfo = async (fontPath: string): Promise<FRes> => {
    if (!fontPath) {
        return null;
    }
    let promise = cacheFontInfoMap.get(fontPath);
    if (!promise) {
        promise = new Promise<FRes>((resolve, reject) => {
            opentype.load(fontPath, (err, font) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(font);
                }
            });
        });
        cacheFontInfoMap.set(fontPath, promise);
    }
    return promise;
};

export const getFontInfoByUrl = async (fontUrl: string) => {
    if (!fontUrl) {
        return undefined;
    }

    let fontInfo = null as any;
    try {
        fontInfo = (await getFontInfo(fontUrl)) as any;
    } catch (error) {
        return undefined;
    }

    if (!fontInfo) {
        return undefined;
    }

    const unitsPerEm = fontInfo.unitsPerEm;

    return {
        lineHeight: (fontInfo.tables.hhea.ascender + Math.abs(fontInfo.tables.hhea.descender)) / unitsPerEm,
        fontInfo,
    };
};

export const adjustTextPositionByFont = async (
    fontInfo: any,
    boundsInfo: any,
    newHeight: number,
    top: number,
    fontSize: number,
    lineSpacing: number,
) => {
    if (!fontInfo) {
        return 0;
    }
    const boundingBoxTop = boundsInfo.boundingBox.top.value;

    const h5LineHeight = fontInfo.lineHeight * fontSize;
    // 抹平 ps 跟 h5 之间的 bounding 差
    const { unitsPerEm, ascender, descender } = fontInfo.fontInfo;
    const h5BoundingTop = fontSize * (ascender / unitsPerEm);
    // fix psBounding 为空
    const psBoundingTop = -boundingBoxTop * boundsInfo.textScale || h5BoundingTop;

    const topOffset = psBoundingTop - h5BoundingTop + (h5LineHeight - newHeight) / 2;
    return topOffset;
};
